import { authPost } from '../http_client.js';

export async function reportAppsflyerAttribution( payload: Record<string, unknown> ): Promise<{ content_mode: string | null }>
{
  return authPost<{ content_mode: string | null }>( 'api/player/me/appsflyer-attribution', payload );
}
